import { EnvironmentInjector, inject, runInInjectionContext } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { LanguageService } from "src/app/core/services/language.service";

export function localizeRoute(route: string, injector: EnvironmentInjector): string {
	let url!: string;
	return runInInjectionContext(injector, () => {
		const languageService = inject(TranslocoService);
		languageService.langChanges$.subscribe((lang) => {
			url = `/${lang}${route}`
		})
		return url;
	})
}